var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col" }, [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c("card-header", {
            attrs: { title: _vm.$router.currentRoute.meta.title }
          }),
          _c(
            "form",
            {
              attrs: { role: "form" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.create($event)
                }
              }
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _vm.serverError
                      ? _c("div", { staticClass: "alert alert-danger" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("labels.error")) + " : ")
                          ]),
                          _vm._v(" " + _vm._s(_vm.serverError) + " ")
                        ])
                      : _vm._e()
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("select-ticket-related-types", {
                      attrs: {
                        options: {
                          id: "ticket_related_type",
                          label: "related_type",
                          error: _vm.fieldErrors.relatedType
                        }
                      },
                      model: {
                        value: _vm.related_type,
                        callback: function($$v) {
                          _vm.related_type = $$v
                        },
                        expression: "related_type"
                      }
                    }),
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "order_id",
                          label: "brisk_id",
                          error: _vm.fieldErrors.orderId
                        }
                      },
                      model: {
                        value: _vm.order_id,
                        callback: function($$v) {
                          _vm.order_id = $$v
                        },
                        expression: "order_id"
                      }
                    }),
                    _c("select-ticket-owner-types", {
                      attrs: {
                        options: {
                          id: "owner_type",
                          label: "owner_type",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.owner_type,
                        callback: function($$v) {
                          _vm.owner_type = $$v
                        },
                        expression: "owner_type"
                      }
                    }),
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "owner_name",
                          label: "owner_name",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.getProfile.name,
                        callback: function($$v) {
                          _vm.$set(_vm.getProfile, "name", $$v)
                        },
                        expression: "getProfile.name"
                      }
                    }),
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "assignee",
                          label: "assignee",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.getProfile.name,
                        callback: function($$v) {
                          _vm.$set(_vm.getProfile, "name", $$v)
                        },
                        expression: "getProfile.name"
                      }
                    }),
                    _c("select-ticket-root-language-codes", {
                      attrs: {
                        options: {
                          id: "language_code",
                          label: "language_code",
                          placeholder: "placeholders.all",
                          onAddHandler: _vm.onLanguageUpdated
                        }
                      },
                      model: {
                        value: _vm.language_code,
                        callback: function($$v) {
                          _vm.language_code = $$v
                        },
                        expression: "language_code"
                      }
                    }),
                    _c("select-ticket-category", {
                      ref: "category_id",
                      attrs: {
                        languageCode: _vm.language_code,
                        options: {
                          disabled:
                            _vm.language_code == null ||
                            _vm.language_code == undefined,
                          id: "category_id",
                          label: "category_id",
                          onAddHandler: _vm.onCategoryUpdated
                        }
                      },
                      model: {
                        value: _vm.category_id,
                        callback: function($$v) {
                          _vm.category_id = $$v
                        },
                        expression: "category_id"
                      }
                    }),
                    _c("select-ticket-subcategory", {
                      ref: "subcategory_id",
                      attrs: {
                        categoryId: _vm.category_id,
                        options: {
                          disabled:
                            _vm.category_id == null ||
                            _vm.category_id == undefined,
                          id: "subcategory_id",
                          label: "subcategory_id",
                          error: _vm.fieldErrors.subcategoryId,
                          error: _vm.fieldErrors.subCategoryId
                        }
                      },
                      model: {
                        value: _vm.subcategory_id,
                        callback: function($$v) {
                          _vm.subcategory_id = $$v
                        },
                        expression: "subcategory_id"
                      }
                    }),
                    _c("input-textarea", {
                      attrs: {
                        options: {
                          id: "initial_message",
                          label: "initial_message",
                          containerClass: "col-12",
                          error: _vm.fieldErrors.initialMessage
                        }
                      },
                      model: {
                        value: _vm.initial_message,
                        callback: function($$v) {
                          _vm.initial_message = $$v
                        },
                        expression: "initial_message"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "card-footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col text-right" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-neutral btn-sm",
                          attrs: { to: { name: _vm.routePrefix + ".index" } }
                        },
                        [_c("i", { staticClass: "fa fa-arrow-left" })]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "submit", disabled: _vm.loading }
                        },
                        [
                          _vm.loading
                            ? _c("span", {
                                staticClass: "spinner-border spinner-border-sm"
                              })
                            : _vm._e(),
                          _c("i", { staticClass: "fa fa-save" })
                        ]
                      )
                    ],
                    1
                  )
                ])
              ])
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }